__turbopack_context__.v({
  "divider": "main-module-scss-module__KToRWq__divider",
  "divider__default": "main-module-scss-module__KToRWq__divider__default",
  "divider__mobile": "main-module-scss-module__KToRWq__divider__mobile",
  "ltr": "main-module-scss-module__KToRWq__ltr",
  "main": "main-module-scss-module__KToRWq__main",
  "main__default": "main-module-scss-module__KToRWq__main__default",
  "main__mobile": "main-module-scss-module__KToRWq__main__mobile",
  "month-button": "main-module-scss-module__KToRWq__month-button",
  "rtl": "main-module-scss-module__KToRWq__rtl",
  "scroll-more-area": "main-module-scss-module__KToRWq__scroll-more-area",
  "tables-container": "main-module-scss-module__KToRWq__tables-container",
  "tables-container__default": "main-module-scss-module__KToRWq__tables-container__default",
});
